const getInitialState = () => ({ open: null });

export const actions = {
  open: (state, id) => ({ ...state, open: id }),
  close: state => ({ ...state, open: null }),
};

export default {
  getInitialState,
  actions,
};



// WEBPACK FOOTER //
// ./state/accordian.js